module.exports = __webpack_public_path__ + "static/media/logo-iolabs-black.11ea54d5.svg";